import { render, staticRenderFns } from "./ClassificacaoFormulario.vue?vue&type=template&id=4f4eb543"
import script from "./ClassificacaoFormulario.vue?vue&type=script&lang=js"
export * from "./ClassificacaoFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports